import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Icon from '../Common/Icon';

// If you pass in an icon it will override the text

const Button = ({ type, bootstrapClass, name, text, iconName, onClick, isDisabled, isModalDismiss }) => {
    const child = (iconName) ? <Icon name={iconName} /> : text;
    const bsClass = (bootstrapClass) ? " btn-" + bootstrapClass : "";
    const cls = "btn" + bsClass;

    // React's "flushing the event boundary" ensures a consistent user experience for immediate, interactive feedback, allowing developers to rely on the DOM state being current during the lifetime of a top-level event handler
    const [disabled, setDisabled] = useState(false);

    // Prevents multiple clicks
    const handleClick = (e) => {
        if (onClick && !disabled) {
            
            setDisabled(true);
            const result = onClick(e);

            if (result instanceof Promise) {
                // It's an async click function, resolve the promise then enable the button
                result.then().finally(() => {
                    setDisabled(false);
                });
            } else {
                // It's a synchronous click function, enable the button directly
                setDisabled(false);
            }
        }
    }

    return (
        <>
            { isDisabled || disabled ?
                <button name={name} type={type} title={text} className={cls} onClick={handleClick} {...(isModalDismiss ? { 'data-dismiss': 'modal' } : {})} disabled>{child}</button>        
            :
                <button name={name} type={type} title={text} className={cls} onClick={handleClick} {...(isModalDismiss ? { 'data-dismiss': 'modal' } : {})}>{child}</button>
            }            
        </>
    );
};

Button.propTypes = {
    type: PropTypes.string.isRequired,
    bootstrapClass: PropTypes.string,
    name: PropTypes.string,
    text: PropTypes.string,
    onClick: PropTypes.func,
    iconName: PropTypes.string,
    isDisabled: PropTypes.bool,
    isModalDismiss: PropTypes.bool,
};

export default Button;